import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem4sm6xs12,
} from '../../../business-components/Grid/Grid'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoPatrimonioImobilizadoList from '../../../business-rules/List/tipoPatrimonioImobilizadoList'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoPatrimonioImobilizado,
    rowPertentePagePatrimonioImobilizado,
    setPageInclusaoPatrimonioImobilizado,
} from './GarantiasCompPatrimonioImobilizado'

import {
    incrementaContPatrimonioImobilizado,
    processaRegistrosDefaultIniciaisPatrimonioImobilizado,
    processaValoresDefaultIniciaisPatrimonioImobilizado,
    calculaTotaisPatrimonioImobilizado,
} from './GarantiasServicePatrimonioImobilizado'

import GarantiasFormPatrimonioImobilizadoItem from './GarantiasFormPatrimonioImobilizadoItem'



const GarantiasFormPatrimonioImobilizado = ({ values, handleChange, setFieldValue }) => {

    calculaTotaisPatrimonioImobilizado(values)
    
    useSingleton(async () => {

        values.pagePatrimonioImobilizado = obtemPage(values.pagePatrimonioImobilizadoList, Number.parseInt(values.familiarPatrimonioImobilizado))
    })

    salvaPage(values.pagePatrimonioImobilizado, values.pagePatrimonioImobilizadoList, Number.parseInt(values.familiarPatrimonioImobilizado))

    let indAux = 0

    values.patrimonioImobilizadoPagination =
        values.patrimonioImobilizado
            ?
                values.patrimonioImobilizado.filter(item => item.familiar === Number.parseInt(values.familiarPatrimonioImobilizado))
            :
                []



    return (
        <>
            <PanelRadioGroup
                name="familiarPatrimonioImobilizado"
                value={Number.parseInt(values.familiarPatrimonioImobilizado) || ''}
                onChange={(e) => {
                    values.pagePatrimonioImobilizado = obtemPage(values.pagePatrimonioImobilizadoList, Number.parseInt(e.target.value))
                    handleChange(e)
                }}
                list={values.totalPatrimonioImobilizado}
                onBlur={
                    processaRegistrosDefaultIniciaisPatrimonioImobilizado(values,
                        Number.parseInt(values.familiarPatrimonioImobilizado))
                }
                helpText={HELPTEXT.patrimonioImobilizadoPanelRadioGroup}
            />
               
            <FieldArray name="patrimonioImobilizado">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.patrimonioImobilizado?.map((item, ind) => {

                                processaValoresDefaultIniciaisPatrimonioImobilizado(item, values)
                                
                                let tipoPatrimonioImobilizadoSelecionado = pesquisaList(tipoPatrimonioImobilizadoList, 
                                    item.tipoPatrimonioImobilizado)

                                return item.familiar === Number.parseInt(values.familiarPatrimonioImobilizado) &&
                                rowPertentePagePatrimonioImobilizado(values, indAux++) ? (
                                    <GridItem4sm6xs12
                                        key={ind}
                                    >
                                        <GarantiasFormPatrimonioImobilizadoItem
                                            values={values}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            arrayHelpers={arrayHelpers}
                                            tipoPatrimonioImobilizadoSelecionado={
                                                tipoPatrimonioImobilizadoSelecionado
                                            }
                                            item={item}
                                            ind={ind}
                                            simplificado={false}
                                        />
                                    </GridItem4sm6xs12>
                                )
                                :
                                (
                                   ''
                                )
                            })}
                        </GridContainer>

                        <TablePaginationPadraoPatrimonioImobilizado
                            values={values}
                            setFieldValue={setFieldValue}
                        />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirPatrimonioImobilizado} 
                            disabled={familiaresList(values).length === 0 || !values.familiarPatrimonioImobilizado ? true : false}
                            onClick={() => 
                                {
                                    incrementaContPatrimonioImobilizado(values)
                                    arrayHelpers.push({
                                        id: values.contPatrimonioImobilizado,
                                        familiar: Number.parseInt(values.familiarPatrimonioImobilizado)
                                    })
                                    setPageInclusaoPatrimonioImobilizado(values, setFieldValue)
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default GarantiasFormPatrimonioImobilizado